import gql from 'graphql-tag'

export default gql`
    mutation deleteIgnore($ProductID: String!) {
        deleteIgnore(ProductID: $ProductID)
    }
`
